export function ContactSection() {
  return (
    <section id="contact" className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-earth-green mb-4 handwriting">
            來找我們聊聊
          </h2>
          <p className="text-xl text-tea-brown">
            就像鄰居一樣，隨時歡迎您來坐坐、聊聊
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-warm-beige rounded-xl p-8 text-center soft-hover warm-shadow">
            <div className="w-16 h-16 bg-earth-green/10 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="fas fa-envelope text-2xl text-earth-green"></i>
            </div>
            <h3 className="text-xl font-semibold text-earth-green mb-3 handwriting">
              寫信給我們
            </h3>
            <p className="text-tea-brown mb-4 text-sm">
              有什麼想法都可以寫信來
            </p>
            <a
              href="mailto:contact@mayiai.com"
              className="text-earth-green font-medium"
            >
              contact@mayiai.com
            </a>
          </div>

          <div className="bg-warm-beige rounded-xl p-8 text-center soft-hover warm-shadow">
            <div className="w-16 h-16 bg-earth-green/10 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="fas fa-map-marker-alt text-2xl text-earth-green"></i>
            </div>
            <h3 className="text-xl font-semibold text-earth-green mb-3 handwriting">
              來我們這裡坐坐
            </h3>
            <p className="text-tea-brown mb-4 text-sm">歡迎來台中找我們</p>
            <p className="text-earth-green font-medium">台中市</p>
          </div>

          <div className="bg-warm-beige rounded-xl p-8 text-center soft-hover warm-shadow">
            <div className="w-16 h-16 bg-earth-green/10 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="fas fa-leaf text-2xl text-earth-green"></i>
            </div>
            <h3 className="text-xl font-semibold text-earth-green mb-3 handwriting">
              一起做好事
            </h3>
            <p className="text-tea-brown mb-4 text-sm">參與社區發展計畫</p>
            <a
              className="text-earth-green font-medium"
              href="https://corp.mediatek.tw/genius-for-home/news/%E7%AC%AC%E5%85%AB%E5%B1%86%E6%99%BA%E5%9C%A8%E5%AE%B6%E9%84%89-%E5%BD%B1%E9%9F%BF%E5%8A%9B%E5%8A%A0%E9%80%9F%E8%A8%88%E7%95%AB%E9%96%8B%E8%B7%91-%E6%AD%A1%E8%BF%8E%E6%9C%89%E6%99%BA%E4%B9%8B%E5%A3%AB%E5%A0%B1%E5%90%8D%E5%8F%83%E8%88%87"
            >
              智在家鄉 2025
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
